<template>
<div>
    <Header />
    <router-view></router-view>
    <Footer v-if="!flag"/>
</div>
</template>

<script>
import Header from '../../components/Header/Header.vue';
import Footer from '../../components/Footer/footer';
import index from './index'
export default {
    ...index,
    components : {
        Header,
        Footer
    }
}
</script>